import * as XLSX from "xlsx";

// Los reportes de TikTok traen el ID del SKU (19 digitos) y el ID del pedido (18) como NUMERO de
// Excel. Un numero de JS solo guarda 15-16 digitos exactos, asi que al leerlos se redondean
// (1737122008733615709 → 1737122008733615600) y dos IDs distintos pueden quedar iguales.
// Este lector abre el libro normal y, en cada hoja, regresa como texto exacto (tomado del XML del
// archivo) los enteros de 16 digitos o mas. Si no es .xlsx (xls/csv) se queda como lo lee XLSX.
const ENTERO_LARGO = /^-?\d{16,}$/;

const textoDe = (wb, ruta) => {
  const f = wb.files && (wb.files[ruta] || wb.files["/" + ruta]);
  return f && f.content ? new TextDecoder().decode(f.content) : "";
};
const atributo = (tag, nombre) => {
  const m = tag.match(new RegExp(`\\b${nombre}="([^"]*)"`));
  return m ? m[1] : "";
};
const desescapar = (t) =>
  t
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, "&");

// hoja -> ruta del XML (xl/workbook.xml + sus relaciones)
const rutasDeHojas = (wb) => {
  const libro = textoDe(wb, "xl/workbook.xml");
  const rels = textoDe(wb, "xl/_rels/workbook.xml.rels");
  const destino = {};
  (rels.match(/<Relationship\b[^>]*>/g) || []).forEach((tag) => {
    const t = atributo(tag, "Target");
    if (t) destino[atributo(tag, "Id")] = t.startsWith("/") ? t.slice(1) : `xl/${t}`;
  });
  const rutas = {};
  (libro.match(/<sheet\b[^>]*>/g) || []).forEach((tag) => {
    const rid = (tag.match(/\b\w+:id="([^"]*)"/) || [])[1];
    if (rid && destino[rid]) rutas[desescapar(atributo(tag, "name"))] = destino[rid];
  });
  return rutas;
};

export function leerExcelNumerosLargos(data) {
  const wb = XLSX.read(data, { type: "array", bookFiles: true });
  if (!wb.files) return wb;
  const rutas = rutasDeHojas(wb);
  for (const nombre of wb.SheetNames) {
    const ws = wb.Sheets[nombre];
    const xml = rutas[nombre] ? textoDe(wb, rutas[nombre]) : "";
    if (!ws || !xml) continue;
    const celda = /<c\b([^>]*)>/g;
    let m;
    while ((m = celda.exec(xml))) {
      const attrs = m[1];
      if (attrs.endsWith("/")) continue; // celda vacia <c ... />
      const fin = xml.indexOf("</c>", celda.lastIndex);
      if (fin < 0) break;
      const ref = atributo(attrs, "r");
      const tipo = atributo(attrs, "t") || "n";
      const v = ((xml.slice(celda.lastIndex, fin).match(/<v>([^<]*)<\/v>/) || [])[1] || "").trim();
      if (ref && tipo === "n" && ENTERO_LARGO.test(v) && ws[ref]) ws[ref] = { t: "s", v, w: v };
    }
  }
  return wb;
}
